import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	static values = { longPressTime: Number };

	timeout = null;
	isLong = false;
	longPressTarget = null;

	connect() {
		this.longPressTime = this.longPressTimeValue || 500;
		this.element.addEventListener("contextmenu", this.onContextMenu, { passive: false });
		this.element.addEventListener("touchstart", this.onTouchStart, { passive: false });
		this.element.addEventListener("touchend", this.onTouchEnd);
		this.element.addEventListener("touchmove", this.onTouchMove);
		this.element.addEventListener("touchcancel", this.onTouchCancel);
	}

	disconnect() {
		this.element.removeEventListener("contextmenu", this.onContextMenu);
		this.element.removeEventListener("touchstart", this.onTouchStart);
		this.element.removeEventListener("touchend", this.onTouchEnd);
		this.element.removeEventListener("touchmove", this.onTouchMove);
		this.element.removeEventListener("touchcancel", this.onTouchCancel);
		this.clear();
	}

	onTouchCancel = () => { this.clear(); }
	onTouchMove = () => { this.clear(); }

	onContextMenu = (e) => {
		// longPressTarget means mobile, and touch start has begun on proper target
		if (this.longPressTarget) {
			e.preventDefault();
			return;
		}

		// desktop right click
		const target = e.target.closest("[data-action*='right-click->']");
		if (target) {
			e.preventDefault();
			this.dispatchRightClick(e.target)

			return;
		}

		// outside of a long press target, desktop and mobil
		return;
	}

	onTouchStart = (e) => {
		const target = e.target.closest("[data-action*='right-click->']");
		if (!target) {
			return; // skip preventDefault; let normal context menu show
		}

		this.longPressTarget = target;

		// NOTE: below disables scrolling by CSS, instead of using preventDefault, since the latter would disable scrolling as well. (iOS)
		this.longPressTarget.classList.add("user-select-none"); // prevent selection

		this.timeout = setTimeout(() => {
			this.isLong = true;
			this.dispatchRightClick(target, e);
		}, this.longPressTime);
	}

	onTouchEnd = (e) => {
		if (!this.timeout) {
			return;
		}

		const isLong = this.isLong;

		this.clear();

		if (isLong) {
			return;
		}

		const target = e.target.closest("[data-action*='right-click->']");
		if (!target) {
			return;
		}

		this.dispatchClick(target, e);
	}

	dispatchClick(target) { target.click(); }

	dispatchRightClick(target, originalEvent) {
		target.dispatchEvent(new CustomEvent("right-click", {
			detail: { originalEvent },
			bubbles: true,
		}));
	}

	clear() {
		clearTimeout(this.timeout);
		this.timeout = null;
		this.isLong = false;

		if (this.longPressTarget) {
			this.longPressTarget.classList.remove("user-select-none");
			this.longPressTarget = null;
		}
	}
}
